import { Button, Col, Form, message, Modal } from 'antd';
import React from 'react';
import { PD_DECLARATION_FORM_FIELDS } from '../../constants/form-fields';
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import { CaseService } from '../../services';

class PDDeclarationForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    savePDDelcaration = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                const normalizedValues = Object.keys(values).reduce((acc, key) => {
                    acc[key] =
                        values[key] === undefined || values[key] === null
                            ? ""
                            : values[key];
                    return acc;
                }, {});

                if (!values.group_entity_involved) {
                    normalizedValues.existing_sanctioned_limit = "";
                }

                CaseService.pdDeclarationSaveDetails(this.props.caseId, normalizedValues)
                    .then((resp) => {
                        this.props.caseJsonDataFetch();
                        message.success("Details Updated Successfully");
                        this.props.showHidePDDeclarationForm();

                    })
                    .catch((err) => {
                        message.error('Something Went Wrong!');
                        this.props.showHidePDDeclarationForm();
                    })
            }
        });
    }

    handleFieldValueChange = (fieldName, value) => {
        if (fieldName == "group_entity_involved") {
            this.props.form.setFieldsValue({
                existing_sanctioned_limit: '',
            })
        }
    }

    renderForm = () => {
        return PD_DECLARATION_FORM_FIELDS.map((field, fieldName) => {
            let fieldProps = { ...field };
            if (fieldName === 'existing_sanctioned_limit') {
                const isGroupEntityYes = this.props.form.getFieldValue("group_entity_involved") === true;
                fieldProps.disabled = !isGroupEntityYes;
                fieldProps.rules = isGroupEntityYes
                    ? [{ required: true, message: "Existing Sanctioned Limit is required when Group Entity Involved is Yes" }]
                    : [{ required: false }];
            }
            const value = this.props.values && this.props.values[fieldName];
            return <Col span={fieldProps.col}>{this.fieldGenerator(
                fieldName,
                { ...fieldProps, value },
                this.getValidateStatus(fieldName),
                (e) => this.handleFieldValueChange(fieldName, (field.type == "SELECT" ? e : e.target.value)),
                true
            )()}</Col>;
        }).toList();
    }
    render() {
        console.log("this.props.stageId", this.props.stageId)
        return (
            <Modal
                title="PD Declaration Form"
                visible={true}
                onOk={[7, 8].includes(this.props.stageId) ? () => { this.savePDDelcaration() } : null}
                okButtonProps={{
                    disabled: ![7, 8].includes(this.props.stageId)
                }}
                onCancel={() => this.props.showHidePDDeclarationForm()}
            >
                <Form className='displayInline form-custom-helper'>
                    {this.renderForm()}
                </Form>
            </Modal>

        )
    }
}

export default Form.create({
    mapPropsToFields: ({ values }) => {
        if (!values) return {};
        const fields = {};
        Object.keys(values).forEach(key => {
            let value = values[key];
            if (value === "") {
                value = undefined;
            }
            fields[key] = Form.createFormField({ value });
        });

        return fields;
    }
})(PDDeclarationForm);
